import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, clearTokens, refreshSession } from "@/lib/api";
import { getSource } from "@/lib/track";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // OAuth callback: AuthCallback exchanges the session first
    if (window.location.hash?.includes("session_id=")) return;
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(async () => {
        try {
          await refreshSession();
          const r = await api.get("/auth/me");
          setUser(r.data);
        } catch (_) {
          setUser(false);
        }
      });
  }, []);

  const userId = user ? user.id : null;
  useEffect(() => {
    if (userId) api.post("/track", getSource()).catch(() => {});
  }, [userId]);

  const logout = useMemo(() => async () => {
    await api.post("/auth/logout").catch(() => {});
    clearTokens();
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, logout }), [user, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
